export enum Q {
  ROWS = 'rows',
  USER = 'user',
  BASE = 'base',
  TABLE = 'table',
  TABLES = 'tables',
  ADDONS = 'a'
}
